export const dayRangeHeight = 68;

export const rangeStep = 15;

export const minutesPerHour = 60;

export const minuteHeight = dayRangeHeight / rangeStep;

export const eightHoursInMinutes = 480;
